/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Key_Offline_HintInputs */



/**
* | output |
* | --- |
* | "No internet on this computer?" |
*
* @param {License_Key_Offline_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_key_offline_hint = /** @type {((inputs?: License_Key_Offline_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Key_Offline_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas d'Internet sur cet ordinateur ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Internet auf diesem Computer?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna connessione su questo computer?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет интернета на этом компьютере?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Sin Internet en este equipo?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此电脑无法联网？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このコンピューターがオフラインの場合")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस कंप्यूटर पर इंटरनेट नहीं है?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem Internet neste computador?")
	return /** @type {LocalizedString} */ ("No internet on this computer?")
});